import socket from '.';
import {
  ChatEvents,
  IChatSocketMessageAdd,
  IChatSocketMessageRemove,
  IChatSocketReadChat,
  IUploadFile,
} from './config';

export const addMessage = async (data: IChatSocketMessageAdd) => {
  console.log('Send message......', data);
  socket.emit(ChatEvents.AddChatMessage, data);
};

export const removeMessage = async (data: IChatSocketMessageRemove) => {
  socket.emit(ChatEvents.RemoveChatMessage, data);
};

export const readChat = async (data: IChatSocketReadChat) => {
  socket.emit(ChatEvents.ReadChatgroup, data);
};
